import { DONATION_LIST_IMG_URL, FUNDRAISING_ENDS_IMG_URL } from "@/config";

export const InfoNx = {
  partners: {
    nuanwa: {
      name: '暖哇',
      probability: 80,
      slots: {
        details_users: {
          ads: {
            DETAILS_USERS_A: {
              id: 'WITHDRAWAL_POP_ADS_A',
              imgUrl: require('@/assets/info/insurance-content1_d.png'),
              eventName: 'Jump-to-insurance1-nuamwa',
              content: `{"key":"点击详情页上","partners":"暖哇"}`,
              jumpUrl: 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025072506',
              partners: '暖哇',
              probability: 50,
            },
            DETAILS_USERS_B: {
              id: 'WITHDRAWAL_POP_ADS_A',
              imgUrl: require('@/assets/info/insurance-content4.png'),
              eventName: 'Jump-to-insurance1b-nuamwa',
              content: `{"key":"点击详情页上b","partners":"暖哇"}`,
              jumpUrl: 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025071701',
              partners: '暖哇',
              probability: 50,
            },
          },
        },
        minddle_details:{
          ads: {
            MIDDLE_DETAILS_A: {
              id: 'MIDDLE_DETAILS_A',
              imgUrl: require('@/assets/info/insurance-content2.gif'),
              eventName: 'Jump-to-insurance2-nuamwa',
              content: `{"key":"点击详情页中","partners":"暖哇"}`,
              jumpUrl: 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2026042314',
              partners: '暖哇',
              probability: 50,
            },
            MIDDLE_DETAILS_B: {
              id: 'MIDDLE_DETAILS_B',
              imgUrl: require('@/assets/info/insurance-all2.png'),
              eventName: 'Jump-to-insurance2b-nuamwa',
              content: `{"key":"点击详情页中b","partners":"暖哇"}`,
              jumpUrl: 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025080804',
              partners: '暖哇',
              probability: 50,
            },
          },
        },
        details_page_funds:{
          ads: {
            DETAILS_PAGE_FUNDS:{
              id: 'DETAILS_PAGE_FUNDS',
              imgUrl: require('@/assets/info/insurance-all.png'),
              eventName: 'Jump-to-insurance-suc0-nuamwa',
              content: `{"key":"点击详情页100种","partners":"暖哇"}`,
              jumpUrl: 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025081408',
              partners: '暖哇',
              probability: 50,
            }
          }
        },
        details_below:{
          ads: {
            DETAILS_BELOW_A:{
              id: 'DETAILS_BELOW_A',
              imgUrl: require('@/assets/info/insurance-content4.gif'),
              eventName: 'Jump-to-insurance3-nuamwa',
              content: `{"key":"点击详情页下","partners":"暖哇"}`,
              jumpUrl: 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025081405',
              partners: '暖哇',
              probability: 50,
            },
            DETAILS_BELOW_B:{
              id: 'DETAILS_BELOW_A',
              imgUrl: require('@/assets/info/insurance-under-b.gif'),
              eventName: 'Jump-to-insurance4-nuamwa',
              content: `{"key":"点击详情页下1","partners":"暖哇"}`,
              jumpUrl: 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2026042316',
              partners: '暖哇',
              probability: 50,
            }
          }
        },
        donation_middle_list:{
          ads: {
            DETAILS_BELOW_A:{
              id: 'DETAILS_BELOW_A',
              imgUrl: require('@/assets/info/insurance_700_c.gif'),
              eventName: 'Jump-to-insurance-suc2-nuamwa',
              content: `{"key":"点击详情页捐赠列表中","partners":"暖哇"}`,
              jumpUrl: 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2026042315',
              partners: '暖哇',
              probability: 100,
            },
          }
        },
        donation_list:{
          ads: {
            DONATION_LIST_A:{
              id: 'DONATION_LIST_A',
              imgUrl: require('@/assets/info/insurance_700.png'),
              eventName: 'Jump-to-insurance-suc3-nuamwa',
              content: `{"key":"点击详情页捐赠列表底部","partners":"暖哇"}`,
              jumpUrl: 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025072508',
              partners: '暖哇',
              probability: 100,
            },
          }
        },
        fundraising_ends:{
          ads: {
            FUNDRAISING_ENDS_A:{
              id: 'FUNDRAISING_ENDS_A',
              imgUrl: require('@/assets/info/output-over.gif'),
              eventName: 'Jump-to-finish1-nuamwa',
              content: `{"key":"点击筹款结束弹窗","partners":"暖哇"}`,
              jumpUrl: 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025072504',
              partners: '暖哇',
              probability: 50,
            },
            FUNDRAISING_ENDS_B:{
              id: 'FUNDRAISING_ENDS_B',
              imgUrl: require('@/assets/info/output-over_b.png'),
              eventName: 'Jump-to-finish1b-nuamwa',
              content: `{"key":"点击筹款结束弹窗b","partners":"暖哇"}`,
              jumpUrl: 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025081403',
              partners: '暖哇',
              probability: 50,
            },

          }
        }

      },
    },
    yixin:{
      name: '毅新',
      probability: 5,
      slots: {
        details_users: {
          ads: {
            DETAILS_USERS_A: {
              isWatch:false,
              id: 'WITHDRAWAL_POP_ADS_A',
              imgUrl: require('@/config/assets/yixin/info/details_users.png'),
              eventName: 'JJump-to-insurance1-yixin',
              content: `{"key":"点击详情页上","partners":"毅新"}`,
              jumpUrl: 'https://item.jd.com/10168368014434.html?extension_id=eyJhZCI6IjI2OCIsImNoIjoiMiIsInNrdSI6IjEwMTY4MzY4MDE0NDM0IiwidHMiOiIxNzgxNTg3NTc1IiwidW5pcWlkIjoie1wiY2xpY2tfaWRcIjpcImQ1MjNiNzY5LTc2ZmEtNDI4YS04MzAwLTUzOTVmNWVjMDIwOFwiLFwibWF0ZXJpYWxfaWRcIjpcIjU0NDA1MjAwMTYyXCIsXCJwb3NfaWRcIjpcIjI2OFwiLFwic2lkXCI6XCI1YzQyYTJkZC0xYzFmLTQ1NDEtYjZkNi1lNzU3M2Y1NWMwMzlcIn0ifQ==&jd_pop=d523b769-76fa-428a-8300-5395f5ec0208&abt=0',
              partners: '毅新',
              probability: 100,
            },
          },
        },
        minddle_details:{
          ads: {
            DETAILS_USERS_A: {
              isWatch:false,
              id: 'DETAILS_USERS_A',
              imgUrl: require('@/config/assets/yixin/info/minddle_details.png'),
              eventName: 'JJump-to-insurance2-yixin',
              content: `{"key":"点击详情页中","partners":"毅新"}`,
              jumpUrl: 'https://item.jd.com/10168368014434.html?extension_id=eyJhZCI6IjI2OCIsImNoIjoiMiIsInNrdSI6IjEwMTY4MzY4MDE0NDM0IiwidHMiOiIxNzgxNTg3NTc1IiwidW5pcWlkIjoie1wiY2xpY2tfaWRcIjpcImQ1MjNiNzY5LTc2ZmEtNDI4YS04MzAwLTUzOTVmNWVjMDIwOFwiLFwibWF0ZXJpYWxfaWRcIjpcIjU0NDA1MjAwMTYyXCIsXCJwb3NfaWRcIjpcIjI2OFwiLFwic2lkXCI6XCI1YzQyYTJkZC0xYzFmLTQ1NDEtYjZkNi1lNzU3M2Y1NWMwMzlcIn0ifQ==&jd_pop=d523b769-76fa-428a-8300-5395f5ec0208&abt=0',
              partners: '毅新',
              probability: 100,
            },
          },
        },
        details_page_funds:{
          ads: {
            DETAILS_PAGE_FUNDS:{
              isWatch:false,
              id: 'DETAILS_PAGE_FUNDS',
              imgUrl: require('@/config/assets/yixin/info/details_page.png'),
              eventName: 'Jump-to-insurance-suc0-yixin',
              content: `{"key":"点击详情页100种","partners":"毅新"}`,
              jumpUrl: 'https://item.jd.com/10168368014434.html?extension_id=eyJhZCI6IjI2OCIsImNoIjoiMiIsInNrdSI6IjEwMTY4MzY4MDE0NDM0IiwidHMiOiIxNzgxNTg3NTc1IiwidW5pcWlkIjoie1wiY2xpY2tfaWRcIjpcImQ1MjNiNzY5LTc2ZmEtNDI4YS04MzAwLTUzOTVmNWVjMDIwOFwiLFwibWF0ZXJpYWxfaWRcIjpcIjU0NDA1MjAwMTYyXCIsXCJwb3NfaWRcIjpcIjI2OFwiLFwic2lkXCI6XCI1YzQyYTJkZC0xYzFmLTQ1NDEtYjZkNi1lNzU3M2Y1NWMwMzlcIn0ifQ==&jd_pop=d523b769-76fa-428a-8300-5395f5ec0208&abt=0',
              partners: '毅新',
              probability: 50,
            }
          }
        },
        details_below:{
          ads: {
            DETAILS_BELOW_A:{
              isWatch:false,
              id: 'DETAILS_BELOW_A',
              imgUrl: require('@/config/assets/yixin/info/details_below.png'),
              eventName: 'Jump-to-insurance3-yixin',
              content: `{"key":"点击详情页下","partners":"毅新"}`,
              jumpUrl: 'https://item.jd.com/10168368014434.html?extension_id=eyJhZCI6IjI2OCIsImNoIjoiMiIsInNrdSI6IjEwMTY4MzY4MDE0NDM0IiwidHMiOiIxNzgxNTg3NTc1IiwidW5pcWlkIjoie1wiY2xpY2tfaWRcIjpcImQ1MjNiNzY5LTc2ZmEtNDI4YS04MzAwLTUzOTVmNWVjMDIwOFwiLFwibWF0ZXJpYWxfaWRcIjpcIjU0NDA1MjAwMTYyXCIsXCJwb3NfaWRcIjpcIjI2OFwiLFwic2lkXCI6XCI1YzQyYTJkZC0xYzFmLTQ1NDEtYjZkNi1lNzU3M2Y1NWMwMzlcIn0ifQ==&jd_pop=d523b769-76fa-428a-8300-5395f5ec0208&abt=0',
              partners: '毅新',
              probability: 100,
            },
          }
        },
        donation_middle_list:{
          ads: {
            DONATION_MIDDLE_LIST_A:{
              isWatch:false,
              id: 'DETAILS_BELOW_A',
              imgUrl: require('@/config/assets/yixin/info/donation_middle_list.png'),
              eventName: 'Jump-to-insurance-suc2-yixin',
              content: `{"key":"点击详情页捐赠列表中","partners":"毅新"}`,
              jumpUrl: 'https://item.jd.com/10168368014434.html?extension_id=eyJhZCI6IjI2OCIsImNoIjoiMiIsInNrdSI6IjEwMTY4MzY4MDE0NDM0IiwidHMiOiIxNzgxNTg3NTc1IiwidW5pcWlkIjoie1wiY2xpY2tfaWRcIjpcImQ1MjNiNzY5LTc2ZmEtNDI4YS04MzAwLTUzOTVmNWVjMDIwOFwiLFwibWF0ZXJpYWxfaWRcIjpcIjU0NDA1MjAwMTYyXCIsXCJwb3NfaWRcIjpcIjI2OFwiLFwic2lkXCI6XCI1YzQyYTJkZC0xYzFmLTQ1NDEtYjZkNi1lNzU3M2Y1NWMwMzlcIn0ifQ==&jd_pop=d523b769-76fa-428a-8300-5395f5ec0208&abt=0',
              partners: '毅新',
              probability: 100,
            },
          }
        },
        donation_list:{
          ads: {
            DONATION_LIST_A:{
              isWatch:false,
              id: 'DETAILS_BELOW_A',
              imgUrl: require('@/config/assets/yixin/info/donation_list.png'),
              eventName: 'Jump-to-insurance-suc3-yixin',
              content: `{"key":"点击详情页捐赠列表底部","partners":"毅新"}`,
              jumpUrl: 'https://item.jd.com/10168368014434.html?extension_id=eyJhZCI6IjI2OCIsImNoIjoiMiIsInNrdSI6IjEwMTY4MzY4MDE0NDM0IiwidHMiOiIxNzgxNTg3NTc1IiwidW5pcWlkIjoie1wiY2xpY2tfaWRcIjpcImQ1MjNiNzY5LTc2ZmEtNDI4YS04MzAwLTUzOTVmNWVjMDIwOFwiLFwibWF0ZXJpYWxfaWRcIjpcIjU0NDA1MjAwMTYyXCIsXCJwb3NfaWRcIjpcIjI2OFwiLFwic2lkXCI6XCI1YzQyYTJkZC0xYzFmLTQ1NDEtYjZkNi1lNzU3M2Y1NWMwMzlcIn0ifQ==&jd_pop=d523b769-76fa-428a-8300-5395f5ec0208&abt=0',
              partners: '毅新',
              probability: 100,
            },
          }
        },
        fundraising_ends:{
          ads: {
            FUNDRAISING_ENDS_A:{
              isWatch:false,
              id: 'FUNDRAISING_ENDS_A',
              imgUrl: require('@/config/assets/yixin/info/fundraising_ends.png'),
              eventName: 'Jump-to-finish1-yixin',
              content: `{"key":"点击筹款结束弹窗","partners":"毅新"}`,
              jumpUrl: 'https://item.jd.com/10168368014434.html?extension_id=eyJhZCI6IjI2OCIsImNoIjoiMiIsInNrdSI6IjEwMTY4MzY4MDE0NDM0IiwidHMiOiIxNzgxNTg3NTc1IiwidW5pcWlkIjoie1wiY2xpY2tfaWRcIjpcImQ1MjNiNzY5LTc2ZmEtNDI4YS04MzAwLTUzOTVmNWVjMDIwOFwiLFwibWF0ZXJpYWxfaWRcIjpcIjU0NDA1MjAwMTYyXCIsXCJwb3NfaWRcIjpcIjI2OFwiLFwic2lkXCI6XCI1YzQyYTJkZC0xYzFmLTQ1NDEtYjZkNi1lNzU3M2Y1NWMwMzlcIn0ifQ==&jd_pop=d523b769-76fa-428a-8300-5395f5ec0208&abt=0',
              partners: '毅新',
              probability: 50,
            },
          }
        }
      },
    },
    haohai:{
      name: '浩海',
      probability: 5,
      slots: {
        details_users: {
          ads: {
            DETAILS_USERS_A: {
              isWatch:false,
              id: 'WITHDRAWAL_POP_ADS_A',
              imgUrl: require('@/config/assets/haohai/info/details_users.png'),
              eventName: 'JJump-to-insurance1-haohai',
              content: `{"key":"点击详情页上","partners":"浩海"}`,
              jumpUrl: '',
              partners: '浩海',
              probability: 100,
            },
          },
        },
        minddle_details:{
          ads: {
            DETAILS_USERS_A: {
              isWatch:false,
              id: 'DETAILS_USERS_A',
              imgUrl: require('@/config/assets/haohai/info/minddle_details.png'),
              eventName: 'JJump-to-insurance2-haohai',
              content: `{"key":"点击详情页中","partners":"浩海"}`,
              jumpUrl: '',
              partners: '浩海',
              probability: 100,
            },
          },
        },
        details_page_funds:{
          ads: {
            DETAILS_PAGE_FUNDS:{
              isWatch:false,
              id: 'DETAILS_PAGE_FUNDS',
              imgUrl: require('@/config/assets/haohai/info/details_page.png'),
              eventName: 'Jump-to-insurance-suc0-haohai',
              content: `{"key":"点击详情页100种","partners":"浩海"}`,
              jumpUrl: 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025081408',
              partners: '浩海',
              probability: 50,
            }
          }
        },
        details_below:{
          ads: {
            DETAILS_BELOW_A:{
              isWatch:false,
              id: 'DETAILS_BELOW_A',
              imgUrl: require('@/config/assets/haohai/info/details_below.png'),
              eventName: 'Jump-to-insurance3-haohai',
              content: `{"key":"点击详情页下","partners":"浩海"}`,
              jumpUrl: '',
              partners: '浩海',
              probability: 50,
            },
          }
        },
        donation_middle_list:{
          ads: {
            DONATION_MIDDLE_LIST_A:{
              isWatch:false,
              id: 'DETAILS_BELOW_A',
              imgUrl: require('@/config/assets/haohai/info/donation_middle_list.png'),
              eventName: 'Jump-to-insurance-suc2-haohai',
              content: `{"key":"点击详情页捐赠列表中","partners":"浩海"}`,
              jumpUrl: '',
              partners: '浩海',
              probability: 100,
            },
          }
        },
        donation_list:{
          ads: {
            DONATION_LIST_A:{
              isWatch:false,
              id: 'DETAILS_BELOW_A',
              imgUrl: require('@/config/assets/haohai/info/donation_list.png'),
              eventName: 'Jump-to-insurance-suc3-haohai',
              content: `{"key":"点击详情页捐赠列表底部","partners":"浩海"}`,
              jumpUrl: '',
              partners: '浩海',
              probability: 100,
            },
          }
        },
        fundraising_ends:{
          ads: {
            FUNDRAISING_ENDS_A:{
              isWatch:false,
              id: 'FUNDRAISING_ENDS_A',
              imgUrl: require('@/config/assets/haohai/info/fundraising_ends.png'),
              eventName: 'Jump-to-finish1-haohai',
              content: `{"key":"点击筹款结束弹窗","partners":"浩海"}`,
              jumpUrl: 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025072504',
              partners: '浩海',
              probability: 100,
            },
          }
        }
      },
    },
    yisheng:{
      name: '医生',
      probability: 10,
      slots: {
        details_users: {
          ads: {
            DETAILS_USERS_A: {
              isWatch:false,
              id: 'WITHDRAWAL_POP_ADS_A',
              imgUrl: require('@/config/assets/haohai/info/details_users.png'),
              eventName: 'JJump-to-insurance1-haohai',
              content: `{"key":"点击详情页上","partners":"浩海"}`,
              jumpUrl: '',
              partners: '浩海',
              probability: 100,
            },
          },
        },
        minddle_details:{
          ads: {
            DETAILS_USERS_A: {
              isWatch:false,
              id: 'DETAILS_USERS_A',
              imgUrl: require('@/config/assets/haohai/info/minddle_details.png'),
              eventName: 'JJump-to-insurance2-haohai',
              content: `{"key":"点击详情页上","partners":"浩海"}`,
              jumpUrl: '',
              partners: '浩海',
              probability: 100,
            },
          },
        },
        details_page_funds:{
          ads: {
            DETAILS_PAGE_FUNDS:{
              isWatch:false,
              id: 'DETAILS_PAGE_FUNDS',
              imgUrl: require('@/config/assets/haohai/info/details_page.png'),
              eventName: 'Jump-to-insurance-suc0-haohai',
              content: `{"key":"点击详情页100种","partners":"浩海"}`,
              jumpUrl: 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025081408',
              partners: '浩海',
              probability: 50,
            }
          }
        },
        details_below:{
          ads: {
            DETAILS_BELOW_A:{
              isWatch:false,
              id: 'DETAILS_BELOW_A',
              imgUrl: require('@/config/assets/haohai/info/details_below.png'),
              eventName: 'Jump-to-insurance3-haohai',
              content: `{"key":"点击详情页下","partners":"浩海"}`,
              jumpUrl: '',
              partners: '浩海',
              probability: 50,
            },
          }
        },
        donation_middle_list:{
          ads: {
            DONATION_MIDDLE_LIST_A:{
              isWatch:false,
              id: 'DETAILS_BELOW_A',
              imgUrl: require('@/config/assets/haohai/info/donation_middle_list.png'),
              eventName: 'Jump-to-insurance-suc2-haohai',
              content: `{"key":"点击详情页捐赠列表中","partners":"浩海"}`,
              jumpUrl: '',
              partners: '浩海',
              probability: 100,
            },
          }
        },
        donation_list:{
          ads: {
            DONATION_LIST_A:{
              isWatch:false,
              id: 'DETAILS_BELOW_A',
              imgUrl: require('@/config/assets/haohai/info/donation_list.png'),
              eventName: 'Jump-to-insurance-suc3-haohai',
              content: `{"key":"点击详情页捐赠列表底部","partners":"浩海"}`,
              jumpUrl: '',
              partners: '浩海',
              probability: 100,
            },
          }
        },
        fundraising_ends:{
          ads: {
            FUNDRAISING_ENDS_A:{
              id: 'FUNDRAISING_ENDS_A',
              imgUrl: require('@/config/assets/yisheng/info/fundraising_ends.png'),
              eventName: 'Jump-to-finish1-yisheng',
              content: `{"key":"点击筹款结束弹窗","partners":"yisheng"}`,
              jumpUrl: 'https://medgpt-health.medlinker.com/toc/pages/home/home?utm_source=nuanxinhuimin01&channel_code=nuanxinhuimin01&channel_id=484',
              partners: '医生',
              probability: 100,
            },
          }
        }
      }
    }
  },
}
export const infoPageData = [
  'JJump-to-insurance1-yixin',
  'JJump-to-insurance2-yixin',
  'Jump-to-insurance-suc0-yixin',
  'Jump-to-insurance3-yixin',
  'Jump-to-insurance-suc2-yixin',
  'Jump-to-insurance-suc3-yixin',
  'Jump-to-finish1-yixin',
  'JJump-to-insurance1-haohai',
  'JJump-to-insurance2-haohai',
  'Jump-to-insurance-suc0-haohai',
  'Jump-to-insurance3-haohai',
  'Jump-to-insurance-suc2-haohai',
  'Jump-to-insurance-suc3-haohai',
  'Jump-to-finish1-haohai'
]
